import React from 'react';
import SupplierTable from './SupplierTable';

function EnergyRecurringSuppliersTable({ suppliers, remainedTotal }) {
  return (
    <SupplierTable
      title="Compensi da ricorrenze energia"
      suppliers={suppliers}
      anchorId="info-recurring-energy"
      remainedTotal={remainedTotal}
    />
  );
}

export default EnergyRecurringSuppliersTable;
